<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <div class="form-line" style="margin: 10px 0;">
      <div class="textBox" style="margin-right: 20px;">
        <b class="red">*</b>
        <span class="line-text">标题：</span>
      </div>
      <el-input v-model="title" size="small" style="flex: 1;" />
    </div>
    <div class="form-line" style="margin: 10px 0;">
      <div class="textBox" style="margin-right: 20px;">
        <b class="red">*</b>
        <span class="line-text">出处：</span>
      </div>
      <el-input v-model="source" size="small" style="flex: 1;" />
    </div>
    <div class="form-line" style="margin: 10px 0;">
      <div class="textBox" style="margin-right: 20px;">
        <b class="red">*</b>
        <span class="line-text">类型：</span>
      </div>
      <el-select v-model="ggType" placeholder="请选择" size="mini" style="flex: 1;">
        <el-option
          v-for="item in ggTypeList"
          :key="item.code"
          :label="item.value"
          :value="item.code">
        </el-option>
      </el-select>
    </div>
    <div class="form-line" style="margin: 10px 0 0 0">
      <div class="textBox" style="margin-right: 18px;">
        <span class="line-text">引导图：</span>
      </div>
      <!--<upload-img-list @getImgList="getImgList"  />-->
      <input id="uploadGuidedGraph" name="file" accept="image/*" type="file"
             @change="upData2" style="display: none" />
      <div>
        <a class="newly2" @click="upImg2" v-if="!guideMap">
          <span><i class="el-icon-plus"></i></span>
          <span>点击上传</span>
        </a>
        <a class="upload2" @click="upImg2" v-if="guideMap">
          <img :src="guideMap" id="packBg" />
          <b>重新上传</b>
        </a>
      </div>
    </div>

    <div class="form-line" style="margin: 20px 0;" v-if="ggType === '2'">
      <div class="textBox" style="margin-right: 20px;">
        <b class="red">*</b>
        <span class="line-text">链接地址：</span>
      </div>
      <el-input v-model="url" size="small" style="flex: 1;" />
    </div>
    <div class="form-line" style="margin: 20px 0;" v-if="ggType === '1'">
      <div class="textBox" style="margin-right: 5px;">
        <b class="red"></b>
        <span class="line-text"></span>
      </div>
      <div class="editorBox">
        <quill-editor ref="QuillEditor"
                      v-model="content"
                      class="ql-editor"
                      :options="editorOption"
                      @blur="onEditorBlur($event)"
                      @focus="onEditorFocus($event)"
                      @ready="onEditorReady($event)">
        </quill-editor>
      </div>
    </div>
    <div class="btn-line">
      <button-confirm @confirm="confirm" value="确定" />
      <button-cancel @cancel="cancel" value="返回" />
    </div>
    <div style="width: 0px;height: 0px;" id="showImageDialogVisible" @click="chooseImageDialogVisible = true"></div>

    <el-dialog title="选择图片" :visible.sync="chooseImageDialogVisible" width="500px">
      <div>
        <upload-img-list @getImgList="getImgList" :ImgNumber="1" style="margin: 0 auto" v-if="chooseImageDialogVisible" />
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="chooseImageDialogVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="uploadImg" size="small">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import Breadcrumb from '../../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../../components/Text/TextTitle'
  import ButtonConfirm from '../../../../components/Button/ButtonConfirm'
  import ButtonCancel from '../../../../components/Button/ButtonCancel'
  import {getObjectURL} from '../../../../utils/toBase64'
  import $ from 'jquery'
  import {api} from '../../../api/yqParty'
  import {bus} from '../../../../utils/bus'
  import {nError, nSuccess} from '../../../../utils/notice'
  import {errorHandler} from '../../../../utils/errorHandler'
  import UploadImgList from '../../../../components/Input/UploadImgList'

  const toolbarOptions = [
    ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
    ['blockquote', 'code-block'],

    [{'header': 1}, {'header': 2}],               // custom button values
    [{'list': 'ordered'}, {'list': 'bullet'}],
    [{'script': 'sub'}, {'script': 'super'}],      // superscript/subscript
    [{'indent': '-1'}, {'indent': '+1'}],          // outdent/indent
    [{'direction': 'rtl'}],                         // text direction

    [{'size': ['small', false, 'large', 'huge']}],  // custom dropdown
    [{'header': [1, 2, 3, 4, 5, 6, false]}],

    [{'color': []}, {'background': []}],          // dropdown with defaults from theme
    [{'font': []}],
    [{'align': []}],
    ['link', 'image'],
    ['clean']                                         // remove formatting button
  ]

  export default {
    components: {
      UploadImgList,
      ButtonCancel,
      ButtonConfirm,
      TextTitle,
      Breadcrumb},
    name: 'add-party-information',
    data () {
      return {
        breadcrumb: [{
          value: '资源中心',
          name: 'yq-information'
        }, {
          value: '政策解读'
        }],
        mainTitle: '添加政策解读',
        subheading: '',

        title: '',
        source: '原创',
        ggType: '1',
        ggTypeList: [
          {
            code: '1',
            value: '图文资讯'
          }, {
            code: '2',
            value: '微信推文链接'
          }
        ],
        guideMap: '',
        pictureBase64: '',
        content: '',
        editorOption: {
          modules: {
            toolbar: {
              container: toolbarOptions,  // 工具栏
              handlers: {
                'image': function (value) {
                  if (value) {
                    document.querySelector('#showImageDialogVisible').click()
                  } else {
                    this.quill.format('image', false);
                  }
                }
              }
            }
          }
        },
        responsiblePersonCode: '',
        responsiblePersonName: '',
        chooseImageDialogVisible: false,
        url: '',
        imageList: [],
        base64List: []
      }
    },
    created() {
      this.responsiblePersonCode = bus.global.accountCode
      this.responsiblePersonName = bus.global.accountName
    },
    methods: {
      toyqNoticeManagementPage () {
        this.$router.push({
          name: 'party-information-manage'
        })
      },
      getImgList (imageList, base64List) {
        this.imageList = imageList
        this.base64List = base64List
      },
      onEditorBlur(editor) {},
      onEditorFocus(editor) {},
      onEditorReady(editor) {},
      onEditorChange({ editor, html, text }) {
        // console.log('editor change!', editor, html, text)
        this.content = html
      },

      upData2: function () {
        let that = this
        const oFReader = new FileReader()
        const file = document.getElementById('uploadGuidedGraph').files[0]
        if (file.size > 1024 * 1024) {
          nError('上传图片不能大于1M')
          return false
        }
        oFReader.readAsDataURL(file)
        oFReader.onloadend = function (oFRevent) {
          const src = oFRevent.target.result
          that.pictureBase64 = src
          that.uploadPicture()
        }
      },
      upImg2: function () {
        document.getElementById('#uploadBackgroundImg')
        $('#uploadGuidedGraph')
          .click() // 隐藏了input:file样式后，点击头像就可以本地上传
          .on('change', function () {
            // const objUrl = getObjectURL(this.files[0])
            // if (objUrl) {
            //   $('#pic2').attr('src', objUrl)
            // }
          })
      },

      // 上传图片
      uploadPicture () {
        this.$axios.post(api.uploadImg, {
          picData: this.pictureBase64
        })
          .then(res => {
            if (res.data.retCode === 1) {
              this.guideMap = res.data.data
            } else {
              // 提示信息，需引入Message
              nError('图片上传失败')
            }
          })
          .catch(errorHandler('图片上传失败'))
      },

      // 上传图片
      uploadImg () {
        if (this.base64List.length < 0) {
          nError('请选择图片')
          return false
        }
        this.$axios.post(api.uploadImg, {
          picData: this.base64List[0].personImageStr
        })
          .then(res => {
            if (res.data.retCode === 1) {
              // this.content += `<img src="${res.data.data}">`
              // console.log(this.content)
              let quill = this.$refs.QuillEditor.quill

              let length = quill.selection.savedRange.index

              quill.insertEmbed(length, 'image', res.data.data)

              quill.setSelection(length + 1)
              this.chooseImageDialogVisible = false
              this.imageList = []
              this.base64List = []
            } else {
              // 提示信息，需引入Message
              nError('图片插入失败')
            }
          })
          .catch(errorHandler('图片插入失败'))
      },
      confirm () {
        if (!this.title) {
          nError('请输入标题')
          return false
        }
        let reqData = {
          title: this.title,
          source: this.source || '原创',
          guideMap: this.guideMap,
          url: '',
          content: encodeURI(this.content),
          responsiblePersonCode: this.responsiblePersonCode,
          responsiblePersonName: this.responsiblePersonName
        }
        if (this.ggType === '1') {
          if (!this.content) {
            nError('请输入内容')
            return false
          }
          reqData.content = encodeURI(this.content)
          reqData.url = ''
        } else {
          if (this.url.indexOf('https://mp.weixin.qq.com') === -1) {
            nError('请输入微信推文链接')
            return false
          }
          reqData.content = ''
          reqData.url = this.url
        }
        this.$axios.post(api.addPolicyInterpretation, reqData)
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('添加成功')
              this.toyqNoticeManagementPage()
            }
          })
          .catch(errorHandler('添加失败'))
      },
      cancel () {
        this.toyqNoticeManagementPage()
      }
    }
  }
</script>

<style scoped>
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .red {
    color: #FF0000;
    vertical-align: sub;
  }
  .form-line {
    margin: 20px 0;
    display: flex;
    justify-content: flex-start;
  }
  .form-line>div {
    margin-right: 20px;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 80px;
    line-height: 32px;
    text-align: right;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 110px 0 140px;
    margin: 40px 0 0 0;
    display: flex;
    justify-content: space-between;
  }
  .newly2 {
    display: inline-block;
    width: 160px;
    height: 90px;
    vertical-align: text-top;
    border: 1px dashed #D7D7D7;
    border-radius: 5px;
    margin-right: 20px;
    position: relative;
  }
  .newly2 span {
    display: block;
    width: 100%;
    color: #999999;
    margin: 0;
    padding: 0;
    text-align: center;
  }
  .newly2 span:first-child {
    font-size: 36px;
    line-height: 50px;
    position: absolute;
    top: 15px;
  }
  .newly2 span:last-child {
    font-size: 14px;
    line-height: 30px;
    position: absolute;
    bottom: 0;
  }
  .upload2 {
    display: inline-block;
    width: 160px;
    height: 90px;
    vertical-align: text-top;
    background-size: 100% 100%;
    position: relative;
  }

  .upload2 img {
    width: 100%;
    height: 100%;
    border-radius: 5px;
  }
  .upload2 b {
    display: inline-block;
    width: 100%;
    line-height: 21px;
    color: white;
    border-radius: 5px;
    background-color: #989796;
    text-align: center;
    position: absolute;
    bottom: 0;
    left: 0;
    opacity: .7;
  }
</style>

<style lang="less">
  .el-switch {
    height: 30px;
  }
</style>




// WEBPACK FOOTER //
// src/view/ResourceCenter/PoliticalParty/PartyInformation/AddPartyInformation.vue